// Autogenerated during build time. Do not modify.
export const RICOS_VERSION = '10.102.0';
//# sourceMappingURL=version.js.map